import { render, staticRenderFns } from "./PatientView.vue?vue&type=template&id=633baf8e&scoped=true&"
import script from "./PatientView.vue?vue&type=script&lang=js&"
export * from "./PatientView.vue?vue&type=script&lang=js&"
import style0 from "./PatientView.vue?vue&type=style&index=0&id=633baf8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633baf8e",
  null
  
)

export default component.exports